import Axios from "axios";

const CSCAPI_KEY = "QmRFQmtHNGJrUDB4TkwxR3pIUHVNZWx5aDEyODU1VkZsT0loM3NDMA==";

export var Country = {
  getAllCountries() {
    return new Promise((resolve, reject) => {
      return Axios.get(`https://api.countrystatecity.in/v1/countries`, {
        headers: {
          "X-CSCAPI-KEY": CSCAPI_KEY
        }
      })
        .then(results => {
          if (results.data.length > 0) {
            resolve(results.data);
          }
        })
        .catch(err => {
          console.warn(err);
          reject(err);
        });
    });
  },

  getStatesOfCountry(iso) {
    return new Promise((resolve, reject) => {
      return Axios.get(
        `https://api.countrystatecity.in/v1/countries/${iso}/states`,
        {
          headers: {
            "X-CSCAPI-KEY": CSCAPI_KEY
          }
        }
      )
        .then(results => {
          if (results.data.length > 0) {
            resolve(results.data);
          } else {
            resolve([]);
          }
        })
        .catch(err => {
          console.warn(err);
          resolve([]);
        });
    });
  }
};
